import { string, object, ref, number } from "yup";

export const REFUND_SCHEMA = () =>
  object().shape({
    arnNo: string().required("ARN Number is required"),
    arnDate: string().required("ARN Date is required"),
    arnStatus: string().required("ARN Status is required"),
  });
